export default (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    role="img"
    focusable="false"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Next</title>
    <path d="M26 3v26" stroke="currentColor" strokeWidth="1.5" />
    <path
      d="M25 16 5.5 27.258V4.742L25 16Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="square"
    />
  </svg>
);
